export const bulkFragment = `
    successfulIds
    failedErrors {
      itemId
      index
      message
      messageKey
      data
    }
  `;

export const commonFragment = `
    id
    createdAt
    updatedAt
    tenantId
    externalReference
  `;

export const routeFragment = `
    sections {
      polyline
      summary {
        duration
        length
      }
    }
  `;
